import eSignatureApi from '../../api/e-signature-api';

const E_SIGNATURE_SET_TECHNICAL_ERROR = 'E_SIGNATURE_SET_TECHNICAL_ERROR';
const E_SIGNATURE_SET_CAPTCHA_KEY = 'E_SIGNATURE_SET_CAPTCHA_KEY';
const E_SIGNATURE_SET_CAPTCHA_IMAGE = 'E_SIGNATURE_SET_CAPTCHA_IMAGE';
const E_SIGNATURE_SET_TRANSACTIONS = 'E_SIGNATURE_SET_TRANSACTIONS';
const E_SIGNATURE_SET_CAPTCHA_ERROR = 'E_SIGNATURE_SET_CAPTCHA_ERROR';
const E_SIGNATURE_SET_FORM_TYPE = 'E_SIGNATURE_SET_FORM_TYPE';
const E_SIGNATURE_SET_FORM_DATA = 'E_SIGNATURE_SET_FORM_DATA';
const E_SIGNATURE_RESET_FORM_DATA = 'E_SIGNATURE_RESET_FORM_DATA';
const E_SIGNATURE_SET_BENYUJT_ID = 'E_SIGNATURE_SET_BENYUJT_ID';
const E_SIGNATURE_SET_EAKTA_BENYUJT_FILES = 'E_SIGNATURE_SET_EAKTA_BENYUJT_FILES';
const E_SIGNATURE_ADD_TO_VISITED_PAGES = 'E_SIGNATURE_ADD_TO_VISITED_PAGES';
const E_SIGNATURE_SET_FILE_ERROR = 'E_SIGNATURE_SET_FILE_ERROR';
const E_SIGNATURE_SET_ID_ERROR = 'E_SIGNATURE_SET_ID_ERROR';
const E_SIGNATURE_SET_FILE_NAME = 'E_SIGNATURE_SET_FILE_NAME';
const E_SIGNATURE_SET_SUCCESS = 'E_SIGNATURE_SET_SUCCESS';
const E_SIGNATURE_SET_CURRENT_PAGE = 'E_SIGNATURE_SET_CURRENT_PAGE';
const FORM_DATA_DEFAULT = {
	benyujt: {
		eszignoUgylet: {
			id: null
		},
		dokumentumTipus: null,
		cegnev: null,
		adoszam: null,
		cegjegyzekszam: null,
		email: null,
		korabbiBenyujtId: null
	},
	captchaText: null
};
const eSignatureState = {
	captchaKey: null,
	captchaImage: null,
	transactions: null,
	captchaError: false,
	technicalError: false,
	formData: JSON.parse(JSON.stringify(FORM_DATA_DEFAULT)),
	formType: null,
	benyujtId: null,
	eaktaBenyujtFiles: null,
	visitedPages: [],
	fileError: null,
	fileName: null,
	success: false,
	currentPage: null,
	idError: false
};
const eSignatureGetters = {
	documentTypeText(state) {
		return (
			state.transactions &&
			state.formData &&
			state.formData.benyujt &&
			state.formData.benyujt.eszignoUgylet &&
			state.formData.benyujt.eszignoUgylet.id &&
			state.formData.benyujt.dokumentumTipus &&
			state.transactions.find((transaction) => transaction.id == state.formData.benyujt.eszignoUgylet.id).documentTypes[
				state.formData.benyujt.dokumentumTipus
			]
		);
	},
	eszignoUgyletText(state) {
		return (
			state.transactions &&
			state.formData &&
			state.formData.benyujt &&
			state.formData.benyujt.eszignoUgylet &&
			state.formData.benyujt.eszignoUgylet.id &&
			state.transactions.find((transaction) => transaction.id == state.formData.benyujt.eszignoUgylet.id).name
		);
	}
};
const eSignatureActions = {
	async init({ commit }, formType) {
		try {
			commit(E_SIGNATURE_SET_FORM_TYPE, formType);
			const response = await eSignatureApi.init(formType);
			commit(E_SIGNATURE_SET_CAPTCHA_KEY, response.data.captchaKey);
			commit(E_SIGNATURE_SET_TRANSACTIONS, response.data.transactions);
			if (response.data.htmlFragment) {
				commit(E_SIGNATURE_SET_CAPTCHA_IMAGE, response.data.htmlFragment);
			}
		} catch (err) {
			console.error(err);
			commit(E_SIGNATURE_SET_TECHNICAL_ERROR);
		}
	},
	resetFormData({ commit }) {
		commit(E_SIGNATURE_RESET_FORM_DATA);
	},
	resetBenyujtData({ commit }) {
		commit(E_SIGNATURE_SET_EAKTA_BENYUJT_FILES, null);
	},
	async generateCaptcha({ commit }) {
		const response = await eSignatureApi.generateCaptcha();
		commit(E_SIGNATURE_SET_CAPTCHA_KEY, response.data.captchaKey);
		if (response.data.htmlFragment) {
			commit(E_SIGNATURE_SET_CAPTCHA_IMAGE, response.data.htmlFragment);
		} else {
			commit(E_SIGNATURE_SET_CAPTCHA_IMAGE, null);
		}
	},
	async submitForm({ commit, state, dispatch }, formData) {
		try {
			commit(E_SIGNATURE_SET_CAPTCHA_ERROR, false);
			const formWithoutCaptcha = JSON.parse(JSON.stringify(formData));
			delete formWithoutCaptcha.captchaText;
			commit(E_SIGNATURE_SET_FORM_DATA, formWithoutCaptcha);
			const postData = Object.assign({}, formData, { formType: state.formType, captchaKey: state.captchaKey });
			delete postData.acceptPrivacyStatement;
			const response = await eSignatureApi.submitForm(postData);
			commit(E_SIGNATURE_SET_BENYUJT_ID, response.data.eaktaBenyujt.benyujtId);
		} catch (err) {
			if (err.response.status == 400) {
				const idError = err.response.data.errors['benyujt.korabbiBenyujtId'];
				commit(E_SIGNATURE_SET_ID_ERROR, !!idError);
				const captchaError = err.response.data.errors.captcha;
				if (idError || captchaError) {
					dispatch('generateCaptcha');
				}
				commit(E_SIGNATURE_SET_CAPTCHA_ERROR, !!captchaError);
			} else {
				commit(E_SIGNATURE_SET_TECHNICAL_ERROR);
			}
			throw new Error();
		}
	},
	resetFileError({ commit }) {
		commit(E_SIGNATURE_SET_FILE_ERROR, null);
	},
	resetCaptchaError({ commit }) {
		commit(E_SIGNATURE_SET_CAPTCHA_ERROR, false);
	},
	async submitFile({ commit, state }, file) {
		try {
			const response = await eSignatureApi.submitFile(state.benyujtId, file, state.formType);
			commit(E_SIGNATURE_SET_EAKTA_BENYUJT_FILES, response.data.eaktaBenyujt.eaktaBenyujtFiles);
		} catch (err) {
			if (err.response.status == 400) {
				const fileError = err.response.data.errors.file || err.response.data.errors.benyujt || err.response.data.errors.specified;
				commit(E_SIGNATURE_SET_FILE_ERROR, fileError);
			} else {
				commit(E_SIGNATURE_SET_TECHNICAL_ERROR);
			}
			throw new Error();
		}
	},
	async finalize({ commit, state }) {
		try {
			await eSignatureApi.finalize(state.benyujtId, state.formType);
			commit(E_SIGNATURE_SET_SUCCESS, true);
		} catch (err) {
			commit(E_SIGNATURE_SET_TECHNICAL_ERROR);
			throw new Error();
		}
	},
	addToVisitedPage({ commit }, visitedPage) {
		commit(E_SIGNATURE_ADD_TO_VISITED_PAGES, visitedPage);
	},
	setFileName({ commit }, fileName) {
		commit(E_SIGNATURE_SET_FILE_NAME, fileName);
	},
	setCurrentPage({ commit }, currentPage) {
		commit(E_SIGNATURE_SET_CURRENT_PAGE, currentPage);
	},
	resetSuccess({ commit }) {
		commit(E_SIGNATURE_SET_SUCCESS, false);
	}
};
const eSignatureMutations = {
	[E_SIGNATURE_SET_TECHNICAL_ERROR](state) {
		state.technicalError = true;
	},
	[E_SIGNATURE_ADD_TO_VISITED_PAGES](state, visitedPage) {
		if (!state.visitedPages.includes(visitedPage)) {
			state.visitedPages.push(visitedPage);
		}
	},
	[E_SIGNATURE_SET_CAPTCHA_KEY](state, captchaKey) {
		state.captchaKey = captchaKey;
	},
	[E_SIGNATURE_SET_CAPTCHA_IMAGE](state, captchaImage) {
		state.captchaImage = captchaImage;
	},
	[E_SIGNATURE_SET_TRANSACTIONS](state, transactions) {
		state.transactions = transactions;
	},
	[E_SIGNATURE_SET_CAPTCHA_ERROR](state, captchaError) {
		state.captchaError = captchaError;
	},
	[E_SIGNATURE_SET_FORM_TYPE](state, formType) {
		state.formType = formType;
	},
	[E_SIGNATURE_SET_FORM_DATA](state, formData) {
		state.formData = formData;
	},
	[E_SIGNATURE_SET_BENYUJT_ID](state, benyujtId) {
		state.benyujtId = benyujtId;
	},
	[E_SIGNATURE_SET_EAKTA_BENYUJT_FILES](state, eaktaBenyujtFiles) {
		state.eaktaBenyujtFiles = eaktaBenyujtFiles;
	},
	[E_SIGNATURE_RESET_FORM_DATA](state) {
		state.formData = JSON.parse(JSON.stringify(FORM_DATA_DEFAULT));
	},
	[E_SIGNATURE_SET_FILE_ERROR](state, fileError) {
		state.fileError = fileError;
	},
	[E_SIGNATURE_SET_ID_ERROR](state, idError) {
		state.idError = idError;
	},
	[E_SIGNATURE_SET_FILE_NAME](state, fileName) {
		state.fileName = fileName;
	},
	[E_SIGNATURE_SET_SUCCESS](state, success) {
		state.success = success;
	},
	[E_SIGNATURE_SET_CURRENT_PAGE](state, currentPage) {
		state.currentPage = currentPage;
	}
};
export default {
	namespaced: true,
	state: eSignatureState,
	getters: eSignatureGetters,
	mutations: eSignatureMutations,
	actions: eSignatureActions
};
